import { useState } from 'react';
import { Star } from 'lucide-react';

interface StarRatingInputProps {
  value: number;
  onChange: (rating: number) => void;
  label?: string;
  disabled?: boolean;
  size?: number;
}

/** Keyboard-accessible 1–5 star picker with radio-group semantics. */
const StarRatingInput = ({ value, onChange, label = 'Rating', disabled, size = 32 }: StarRatingInputProps) => {
  const [hover, setHover] = useState(0);
  const shown = hover || value;

  return (
    <div role="radiogroup" aria-label={label} className="inline-flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          role="radio"
          aria-checked={value === n}
          aria-label={`${n} star${n === 1 ? '' : 's'}`}
          disabled={disabled}
          onClick={() => onChange(n)}
          onMouseEnter={() => setHover(n)}
          onMouseLeave={() => setHover(0)}
          onKeyDown={(e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
              e.preventDefault();
              onChange(Math.min(5, (value || 0) + 1));
            } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
              e.preventDefault();
              onChange(Math.max(1, (value || 1) - 1));
            }
          }}
          className="rounded p-0.5 focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50"
        >
          <Star size={size} className={n <= shown ? 'fill-amber-400 text-amber-400' : 'text-gray-300 dark:text-gray-600'} aria-hidden="true" />
        </button>
      ))}
    </div>
  );
};

export default StarRatingInput;
